import { ref, onUnmounted } from 'vue'

export function usePolling(fetchFn: () => Promise<void>, interval: number) {
  const isPolling = ref(false)
  const error = ref<Error | null>(null)
  let timerId: ReturnType<typeof setTimeout> | null = null

  const start = async () => {
    if (isPolling.value) return
    isPolling.value = true
    error.value = null

    const poll = async () => {
      try {
        await fetchFn()
        error.value = null
      } catch (e) {
        error.value = e as Error
        console.error('Polling error:', e)
      }

      if (isPolling.value) {
        timerId = setTimeout(poll, interval)
      }
    }

    await poll()
  }

  const stop = () => {
    isPolling.value = false
    if (timerId) {
      clearTimeout(timerId)
      timerId = null
    }
  }

  onUnmounted(stop)

  return { isPolling, error, start, stop }
}
